import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { render } from "react-dom";
import Home from "./Home";

render(<Home />, document.getElementById("app"));
